export default __webpack_public_path__ + "static/media/Download_App_Store.c23a1d3e.svg";